export enum CheckDictEnum {
  MVK = 'mvk',
  TERROR = 'terror',
  FROMU = 'fromu',
  CONSOLIDATED = 'consolidated',
  OTKAZ = 'otkaz',
  FTS = 'fts',
  NELEGAL = 'nelegal',
  RISK_GROUP = 'riskGroup',
  MSFOUND = 'msfound',
  MSLEAD = 'mslead',
  MS_ADR_INFO = 'ms_adr_info',
  PASSPORT = 'passport',
  UNWANTED = 'unwanted',
  QREF281FZ = 'qref281fz',
  INAGENT = 'inagent',
}
